import React, { useState, useEffect } from 'react';
import './HeroSection.css';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();
  const slides = t('heroSlides', { returnObjects: true });
  const [current, setCurrent] = useState(0);

  const currentImage = slides[current]?.image;

  const nextSlide = () => setCurrent((current + 1) % slides.length);
  const prevSlide = () => setCurrent((current - 1 + slides.length) % slides.length);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') nextSlide();
      if (e.key === 'ArrowLeft') prevSlide();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [current, slides.length]);

  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${currentImage})` }}
    >
      <div className="overlay">
        <h1>{slides[current]?.title}</h1>
        <p>{slides[current]?.text}</p>
      </div>
      <button className="arrow left" onClick={prevSlide}>&#10094;</button>
      <button className="arrow right" onClick={nextSlide}>&#10095;</button>
    </section>
  );
};

export default HeroSection;
